import { graphql } from 'gatsby';
import React from 'react';
import Seo from '../../components/SEO';
import FaqBanner from '../../components/FaqBanner/FaqBanner';
import FaqCover from '../../components/FaqCover/FaqCover';
import FaqLayout from '../../components/FaqLayout/FaqLayout';
import HeaderTheme from '../../components/Header/HeaderTheme';
import Promotions from '../../components/Promotions/Promotions';
import QuestionList from '../../components/QuestionList/QuestionList';
import ServicesList from '../../components/ServicesList/ServicesList';
import Type from '../../components/UI/Type/Type';
import usePromotions from '../../hooks/usePromotions';

const FaqCategoryTemplate = ({
  data: {
    wp: { seo },
    page: { 
      parentId, 
      name, 
      description, 
      faqs, 
      relatedServices,
      sectionPromotions
    },
  },
  location: { pathname }
}) => {
  const promotions = usePromotions(sectionPromotions.promotions, relatedServices.services, {
    excludePath: pathname
  });

  return (
    <>
      <HeaderTheme />
      <Seo
          title={`${name} | FAQs`}
          description={description}
          postSchema={JSON.parse(
            seo.contentTypes.faq.schema.raw
          )}
      />
      <FaqCover />
      <FaqLayout categoryId={parentId}>
        <Type.H1Secondary isBold>{name}</Type.H1Secondary>
        <QuestionList count={1} nodes={faqs.nodes} />

        {!!relatedServices.services && (
          <>
            <Type.MetaHeading>Related service(s)</Type.MetaHeading>
            <ServicesList nodes={relatedServices.services} />
          </>
        )}
      </FaqLayout>
      <FaqBanner />
      <Promotions items={promotions} />
    </>
  );
};

export default FaqCategoryTemplate;

export const query = graphql`
  query faqCategory($id: String!) {
    wp {
      seo {
        contentTypes {
          faq {
            schema {
              raw
            }
          }
        }
      }
    }
    page: wpFaqCategory(id: { eq: $id }) {
      parentId
      name
      description
      faqs {
        nodes {
          title
          uri
          id
        }
      }
      relatedServices {
        services {
          ...ServiceCard
        }
      }
      sectionPromotions {
        promotions {
          promotion {
            ...Promotion
          }
        }
      }
    }
  }
`;
